import { Link } from 'react-router-dom'
import { Leaf, Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Building } from 'lucide-react'

const Footer = () => {
  const contacts = [
    {
      name: 'Ouahibi Hassan',
      role: 'Chargé du secteur Maroc-Afrique',
      phone: '06 60 34 65 12',
      whatsapp: '33770100134',
      email: 'ecotherm0045@gmail.com'
    },
    {
      name: 'Benhalima Samir',
      role: 'Chargé du secteur France-Europe',
      phone: '07 82 62 79 68',
      whatsapp: '33782627968',
      email: 'ldstockeur@gmail.com'
    }
  ]

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Colonne Entreprise */}
          <div>
            <div className="flex items-center gap-2 mb-4">
             
              <div>
                <Link to="/" className="flex items-center gap-3 group">
            {/* Logo image */}
            <img 
              src="images/logo.png"
              alt="ECOTHERM Logo"
              className="h-20 w-auto group-hover:scale-105 transition-transform duration-300"
            />
          </Link>
                <span className="text-green-400 text-sm font-semibold">by LD STOCKEUR</span>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Solutions d'isolation écologique 100% naturelles pour un avenir durable.
              Votre partenaire de confiance pour l'isolation thermique et phonique.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white bg-opacity-10 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors duration-300">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white bg-opacity-10 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors duration-300">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-white bg-opacity-10 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors duration-300">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Colonne Navigation */}
          <div>
            <h3 className="text-lg font-bold mb-6">Navigation</h3>
            <ul className="space-y-3">
              {[
                { path: '/', label: 'Accueil' },
                { path: '/products', label: 'Produits' },
                { path: '/properties', label: 'Propriétés' },
                { path: '/technical', label: 'Fiche Technique' },
                { path: '/application', label: 'Domaines d\'Application' }
              ].map(link => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-400 hover:text-green-400 transition-colors duration-300 flex items-center gap-2">
                    <div className="w-1 h-1 bg-green-400 rounded-full"></div>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne Contacts */}
          <div>
            <h3 className="text-lg font-bold mb-6">Nos Contacts</h3>
            <ul className="space-y-4">
              {contacts.map((contact, index) => (
                <li key={index} className="bg-gray-800 rounded-lg p-3 hover:bg-gray-750 transition-colors duration-300">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white text-xs font-bold">{contact.name.split(' ')[0][0]}</span>
                    </div>
                    <div className="flex-1">
                      <p className="font-semibold text-white text-sm">{contact.name}</p>
                      <p className="text-green-400 text-xs mb-1">{contact.role}</p>
                      <div className="space-y-1">
                        <a 
                          href={`https://wa.me/${contact.whatsapp}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-1 text-gray-400 hover:text-green-400 text-xs transition-colors"
                        >
                          <Phone className="w-3 h-3" />
                          {contact.phone}
                        </a>
                        <a 
                          href={`mailto:${contact.email}`}
                          className="flex items-center gap-1 text-gray-400 hover:text-green-400 text-xs transition-colors"
                        >
                          <Mail className="w-3 h-3" />
                          {contact.email}
                        </a>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne Adresse et Horaires */}
          <div>
            <h3 className="text-lg font-bold mb-6">Informations</h3>
            <div className="space-y-4">
              {/* Adresse */}
              <div className="flex items-start gap-3">
                <Building className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-semibold text-white text-sm">LD STOCKEUR</p>
                  <p className="text-gray-400 text-sm">
                    RDC Quartier MGHAYAR 2, Lot 250<br />
                    90000 TANGER, Maroc
                  </p>
                </div>
              </div>

              {/* Horaires */}
              <div className="bg-gray-800 rounded-lg p-3">
                <p className="font-semibold text-white text-sm mb-2">Horaires d'ouverture</p>
                <div className="space-y-1 text-xs text-gray-400">
                  <div className="flex justify-between">
                    <span>Lun - Ven:</span>
                    <span>9h00 - 18h00</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Samedi:</span>
                    <span>9h00 - 13h00</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Dimanche:</span>
                    <span>Fermé</span>
                  </div>
                </div>
              </div>

              {/* Bouton Contact Direct */}
              <Link 
                to="/contact" 
                className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-lg transition-colors duration-300 text-sm font-semibold"
              >
                <Mail className="w-4 h-4" />
                Nous Contacter
              </Link>
            </div>
          </div>
        </div>

        {/* Section Bas de Footer */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()}  <a href="https://lowcostoffices.site/" className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300">
                lowcostoffices.site
              </a>. Tous droits réservés.
              </p>
              <p className="text-gray-500 text-xs mt-1">
                Solutions d'isolation écologique - Maroc, France, Europe, Afrique
              </p>
            </div>
            <div className="flex gap-6">
              <a href="#" className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300">
                Politique de Confidentialité
              </a>
              <a href="#" className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300">
                Conditions d'Utilisation
              </a>
              <a href="#" className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300">
                Mentions Légales
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer